import { UserPreference } from "./user-preference";
import * as Linq from "linq-es2015";


export class Claim {
    Type: string;
    Value: string;
}

export interface IApplicationUser {
    Name: string;
    IsNotificationAdministrator: boolean;
    AntiforgeryToken: string;
    Preferences: UserPreference[];
	Claims: Claim[];
	TenantName: string;

	hasClaim(type: string): boolean;
	hasAnyClaim(types: string[]): boolean;
    getClaim(type: string, value: string): Claim;
}


export class ApplicationUser implements IApplicationUser {
    Name: string;
    IsNotificationAdministrator: boolean;
    AntiforgeryToken: string;
    Preferences: UserPreference[];
	Claims: Claim[];
	TenantName: string;


	constructor(applicationUser?: IApplicationUser) {
		if (applicationUser) {
			this.init(applicationUser);
		}
	}

    init(applicationUser: IApplicationUser) {
        this.Name = applicationUser.Name;
        this.IsNotificationAdministrator = applicationUser.IsNotificationAdministrator;
        this.AntiforgeryToken = applicationUser.AntiforgeryToken;
        this.Claims = applicationUser.Claims;
		this.Preferences = applicationUser.Preferences;
	    this.TenantName = applicationUser.TenantName;
    }

	hasClaim(type: string): boolean {
		const enumerable = Linq.AsEnumerable(this.Claims);
		return <boolean>enumerable.Any(claim => claim.Type === type);
	}

	hasAnyClaim(types: string[]):boolean {
		const userClaims = Linq.AsEnumerable(this.Claims);
		const claimTypes = Linq.AsEnumerable(types);
		return userClaims.Any(claim => claimTypes.Contains(claim.Type));
	}

	getClaim(type: string, value: string): Claim {
		const enumerable = Linq.AsEnumerable(this.Claims);
		return <Claim>enumerable.FirstOrDefault(claim => claim.Type === type && claim.Value === value);
	}
}